// Sync-required: matching backend file at
// quotebid-backend/src/categories.ts.
// If you change either list, change both.

export const CATEGORY_OPTIONS = [
  // Automotive
  'auto_repair', 'auto_body', 'auto_parts', 'transmission',
  'oil_change', 'tire_service', 'towing',

  // Home trades & construction
  'plumbing', 'electrical', 'hvac', 'electronics', 'roofing', 'gutters',
  'siding', 'awnings', 'painting', 'flooring', 'remodeling', 'concrete',
  'patios', 'fencing', 'pressure_washing', 'appliance_repair',
  'general_contractor', 'windows_doors', 'fence_deck', 'handyman',

  // Outdoor & property
  'landscaping', 'lawn_care', 'tree_service', 'pool_service',

  // Cleaning & removal
  'house_cleaning', 'carpet_cleaning', 'pest_control', 'junk_removal',
  'mold_remediation', 'water_damage_restoration',

  // Pet services
  'dog_training', 'pet_grooming', 'pet_sitting', 'pet_boarding', 'veterinary',

  // Professional & personal services
  'legal', 'accounting', 'insurance', 'real_estate',
  'moving', 'catering', 'photography', 'tutoring',
] as const;

export const MAX_CATEGORIES_PER_BUSINESS = 15;

export type Category = typeof CATEGORY_OPTIONS[number];

// Slugs whose human-readable label needs an ampersand or other punctuation
// that the default Title-Case-from-underscore conversion can't produce.
const DISPLAY_OVERRIDES: Record<string, string> = {
  windows_doors: 'Windows & Doors',
  fence_deck: 'Fence & Deck',
  roofing: 'Roofing',
  pool_service: 'Pool Service & Repair',
  concrete: 'Concrete',
  patios: 'Patios / Patio Covers',
  mold_remediation: 'Mold Removal / Remediation',
  house_cleaning: 'Home Cleaning',
  remodeling: 'Remodeling & Renovation',
  hvac: 'HVAC',
};

// Format a slug for display: 'auto_repair' -> 'Auto Repair'
export function formatCategory(slug: string): string {
  if (DISPLAY_OVERRIDES[slug]) return DISPLAY_OVERRIDES[slug];
  return slug
    .split('_')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
